import { render, staticRenderFns } from "./SelfServicePersonnelRecord.vue?vue&type=template&id=70371d17"
import script from "./SelfServicePersonnelRecord.vue?vue&type=script&lang=js"
export * from "./SelfServicePersonnelRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports